(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/related-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/related-page.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef,
  useState = _React.useState,
  useEffect = _React.useEffect;
const Debug = svs.tur.grid.Debug;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_related.react.components,
  PaymentSuccessInfo = _svs$lyckoplatsen$com.PaymentSuccessInfo,
  ButtonPlay = _svs$lyckoplatsen$com.ButtonPlay,
  CharityCardList = _svs$lyckoplatsen$com.CharityCardList,
  CharityThanksContainer = _svs$lyckoplatsen$com.CharityThanksContainer;
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams;
const Icon = svs.ui.ReactIcon;
const RelatedPage = () => {
  const _useParams = useParams(),
    wagerId = _useParams.wagerId,
    charityId = _useParams.charityId;
  const parsedCharityId = parseInt(charityId, 10);
  const pageRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showGuide = _useState2[0],
    setShowGuide = _useState2[1];
  useEffect(() => {
    setShowGuide(parsedCharityId != null && svs.core.detect.formfactor.mobile());
  }, [parsedCharityId]);
  const handleScrollTo = () => {
    if (pageRef.current) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const targetPos = pageRef.current.getBoundingClientRect().bottom + window.scrollY - headerHeight;
      window.scrollTo({
        top: targetPos,
        behavior: 'smooth'
      });
    }
  };
  return React.createElement("div", {
    className: "u-flex u-flex-grow-1 bg-lyckoplatsen-500 u-flex-justify-content-center u-flex-column"
  }, React.createElement(Debug, null), svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && wagerId && React.createElement("div", {
    className: "lp-page-realated",
    ref: pageRef
  }, React.createElement(PaymentSuccessInfo, {
    charityId: parsedCharityId
  }), parsedCharityId === -2 && React.createElement("div", {
    className: "align-center padding-top-1"
  }, "Tyv\xE4rr \xE4r din valda organisationen inte l\xE4ngre m\xF6jlig att v\xE4lja. ", React.createElement("br", null), "Du kan v\xE4lja en annan organisation att st\xF6tta."), parsedCharityId < 0 ? React.createElement(CharityCardList, {
    wagerId: wagerId
  }) : React.createElement(CharityThanksContainer, {
    charityId: parsedCharityId
  }), showGuide && React.createElement("div", {
    className: "lp-guide-button align-center padding-bottom-2",
    type: "button",
    onClick: handleScrollTo
  }, React.createElement("p", {
    className: "h4"
  }, "Vad h\xE4nder nu?"), React.createElement(Icon, {
    size: "600",
    icon: "menu-down"
  })), React.createElement(ButtonPlay, null)), React.createElement(WidgetArea, {
    areaName: "relatedWidgetArea",
    widgetArea: "relatedWidgetArea"
  }));
};
setGlobal('svs.lyckoplatsen.components.page_related.react', {
  RelatedPage
});

 })(window);